/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
// Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
import { TraceAPI } from './api/trace';
/**
 * Entrypoint for trace API
 *
 * @since 1.0.0
 */
export const trace = TraceAPI.getInstance();
//# sourceMappingURL=trace-api.js.map